module.exports = __webpack_public_path__ + "img/ES3166.f4988959.png";